export function OnThisPage({ items }: { items: { id: string; text: string }[] }) {
  if (items.length < 5) return null;
  return (
    <nav className="on-this-page" aria-label="On this page">
      <div className="mono otp-label">On this page</div>
      <ol>
        {items.map((item) => (
          <li key={item.id}><a href={`#${item.id}`}>{item.text}</a></li>
        ))}
      </ol>
    </nav>
  );
}
